import {
  GET_ME,
  GET_CURRENCY,
  GET_ALL_CUSTOMERS,
  GET_CUSTOMER,
  GET_OPERATIONS,
  GET_ALL_TYPES,
  GET_CATEGORIES,
  CREATE_OPERATION,
  DELETE_OPERATION,
  EDIT_OPERATION,
  GET_ANALYTICS,
  GET_ANALYTICS_OPERATIONS,
  GET_DRAW_OPERATIONS,
  SET_AUTORISATION,
  GET_BONUS,
  GET_TARIFF,
  GET_INVITES_LINK,
  CREATE_CATEGORY,
  EDIT_CATEGORY,
  DELETE_CATEGORY,
  SET_PURCHASE_TARIFF,
  SET_SETTINGS_PUSH,
} from "../../resources/js/helpers/requests";

export default {
  state: {
    token: null,
    currency: [],
    mainCurrency: { id: 2, code_alfa: "USD" },
    customers: [],
    currentCustomer: {},
    currentLang: { id: 2, value: "en", name: "English" },
    perPage: "",
    operations: [],
    drawOperations: [],
    typeOperations: [],
    globalNotification: true,
    categories: [],
    savedOperation: null,
    openedOperation: {
      title: "",
      total_sum: "",
      type: {
        title: "",
      },
      category: {
        title: "",
      },
    },
    invitedFriends: [],
    setMainBonus: {},
    invitedLink: {},
    isOpenMenuSideBar: false,
    isDrawEditMode: false,
    isShowGlobalAnalitycsBlock: false,
    mainAnalytics: [],
    analyticsOperations: [],
    activeAnalyticsData: null,
    actualCurrencyCourse: [],
    createdInfo: {
      price: "",
      title: "",
      currency: null,
      types: null,
      categories: null,
      date: null,
    },
    activeAnalyticType: "expense",
    paymentsTariffs: [],
  },
  mutations: {
    saveAutorisationToken(state, token) {
      state.token = token;
    },
    saveCurrency(state, currency) {
      state.currency = currency;
    },
    setMainCurrency(state, currency) {
      state.mainCurrency = currency;
    },
    setChangeActiveAnalyticType(state, type) {
      state.activeAnalyticType = type;
    },
    saveCustomers(state, customers) {
      state.customers = customers;
    },
    saveLanguages(state, language) {
      state.currentLang = language;
    },
    saveCurrentLang(state, lang) {
      if (lang === "uk") {
        state.currentLang = { id: 1, value: "uk", name: "Українська" };
      } else if (lang === "en") {
        state.currentLang = { id: 2, value: "en", name: "English" };
      } else if (lang === "ru") {
        state.currentLang = { id: 4, value: "ru", name: "Русский" };
      }
    },
    setCurrentCustomer(state, customer) {
      state.currentCustomer = customer;
    },
    addPerPage(state, page) {
      state.perPage = page;
    },
    saveOperations(state, operations) {
      state.operations = operations || [];
    },
    setChangeGlibalNotification(state, value) {
      state.globalNotification = value;
    },
    saveTypeOperations(state, types) {
      state.typeOperations = types;
    },
    saveOneCategories(state, categories) {
      state.categories = categories;
    },
    saveCategories(state, categories) {
      state.categories = [...state.categories, ...categories];
    },
    editCategories(state, category) {
      let categoryIndex = state.categories.findIndex(
        (el) => el.id === category.id
      );
      let data = state.categories;
      let confirmentCategory = {
        ...state.categories[categoryIndex],
        title: category.title,
        img: category.img,
      };
      data.splice(categoryIndex, 1, confirmentCategory);
      state.categories = data;
    },
    deleteCategories(state, category_id) {
      let data = state.categories.filter((el) => el.id !== category_id);
      state.categories = data;
    },
    setSaveOperation(state, operation) {
      state.savedOperation = operation;
    },
    deleteOperationById(state, id) {
      state.operations = state.operations.filter((el) => el.id !== id);
    },
    confirmDrawOperationById(state, id) {
      let indexOperation = state.operations.findIndex((el) => el.id === id);
      let data = state.operations;
      let confirmentOperation = {
        ...state.operations[indexOperation],
        status: "final",
      };
      data.splice(indexOperation, 1, confirmentOperation);
      state.operations = data;
      state.drawOperations = state.drawOperations.filter((el) => el.id !== id);
    },
    addNewOpeation(state, operation) {
      state.operations = [operation, ...state.operations];
    },
    setInvitedFriens(state, friends) {
      state.invitedFriends = friends.bonuses;
      state.setMainBonus = friends;
    },
    editOperation(state, operation) {
      let operationIndex = state.operations.findIndex(
        (el) => el.id === operation.id
      );
      let data = state.operations;
      data.splice(operationIndex, 1, operation);
      state.operations = data;
    },
    saveCreatedInfo(state, operation) {
      state.createdInfo = operation;
    },
    setSaveOpenedOperation(state, operation) {
      state.openedOperation = operation;
    },
    setIsOpenGlobalAnalitycsBlock(state, isOpen) {
      state.isShowGlobalAnalitycsBlock = isOpen;
    },
    setIsOpenMenuSideBar(state, isOpen) {
      state.isOpenMenuSideBar = isOpen;
    },
    setClearCreatedInfo(state) {
      let data = {
        price: "",
        title: "",
        currency: null,
        types: null,
        categories: null,
        date: null,
      };
      state.createdInfo = data;
    },
    setSaveAnalytics(state, data) {
      state.mainAnalytics = data.sort((a, b) => b.sum - a.sum);
    },
    setSaveAnalyticOperations(state, operations) {
      state.analyticsOperations = operations;
    },
    setSaveAnalyticOperationsNextPage(state, operations) {
      state.analyticsOperations = {
        ...operations,
        data: [...state.analyticsOperations.data, ...operations.data],
      };
    },
    setSaveActiveAnalyticsData(state, data) {
      state.activeAnalyticsData = data;
    },
    setSaveDrawOperations(state, data) {
      state.drawOperations = data;
    },
    setIsChangeDrawEditMode(state, value) {
      state.isDrawEditMode = value;
    },
    setInvitedLink(state, link) {
      state.invitedLink = link;
    },
    setPaymentsTariffs(state, tariffs) {
      state.paymentsTariffs = tariffs;
    },
    setCreateNewCategories(state, value) {
      switch (value.type_id) {
        case 1:
          state.incomeCategories = [...state.incomeCategories, value];
          break;
        case 2:
          state.costCategories = [...state.costCategories, value];
          break;
        case 3:
          state.otherCategories = [...state.otherCategories, value];
          break;
      }
    },
  },
  actions: {
    async setAutorisation({ commit }, data) {
      let result = await SET_AUTORISATION(data);
      console.log({ result });
      commit("saveAutorisationToken", result.token);
      return result;
    },
    async getCurrency({ commit, state }) {
      let result = await GET_CURRENCY(state.token);
      commit("saveCurrency", result);
    },
    async getCustomers({ commit, state }) {
      let result = await GET_ALL_CUSTOMERS(state.token);
      commit("saveCustomers", result.data);
    },
    async getCurrentCustomer({ commit, state }, id) {
      let result = await GET_ME(state.token);
      let customer = await GET_CUSTOMER(state.token, id);
      console.log(result, "result");
      console.log(customer, "customer");
      commit("setCurrentCustomer", {
        ...customer[customer.length - 1],
        id: result.id,
        customer_id: customer[customer.length - 1].id,
      });
      const params = {
        data: {
          ...result,
          customers: [customer[customer.length - 1]],
        },
      };
      return params;
    },
    async getOperations({ commit, state }, value) {
      console.log({ value }, 1);
      let result = await GET_OPERATIONS(
        state.token,
        value.id,
        value.platform_id || value?.customers[0]?.platform_id,
        value.from,
        value.to
      );
      commit("saveOperations", result.data);
    },
    async getTypesOperations({ commit, state }, id) {
      let result = await GET_ALL_TYPES(state.token, id);
      commit("saveTypeOperations", result.data);
      return result.data;
    },
    async getCategories({ commit, state }, { account_id, type_id }) {
      let result = await GET_CATEGORIES(state.token, 1, account_id, type_id);
      commit("saveOneCategories", result.data);
      let pages = result.meta.last_page;
      let currentPage = result.meta.current_page;
      for (let i = currentPage; i < pages; i++) {
        let newResult = await GET_CATEGORIES(
          state.token,
          i + 1,
          account_id,
          type_id
        );
        commit("saveCategories", newResult.data);
      }
    },
    async createOperation({ commit, state }, data) {
      let result = await CREATE_OPERATION(state.token, data);
      commit("addNewOpeation", result);
    },
    async deleteOperation({ state }, id) {
      await DELETE_OPERATION(state.token, id);
    },
    async editOperation({ commit, state }, { id, data }) {
      let result = await EDIT_OPERATION(state.token, id, data);
      commit("editOperation", result);
    },
    async getAnalytics({ commit, state }, data) {
      let result = await GET_ANALYTICS(state.token, data);
      if (Array.isArray(result)) {
        commit("setSaveAnalytics", []);
        return result;
      }
      const values = Object.values(result.data);
      commit("setSaveAnalytics", values);
      return result;
    },
    async getAnalyticsOperations({ commit, state }, data) {
      let result = await GET_ANALYTICS_OPERATIONS(state.token, data);
      commit("setSaveActiveAnalyticsData", data);
      if (data?.page > 1) {
        commit("setSaveAnalyticOperationsNextPage", result);
      } else {
        commit("setSaveAnalyticOperations", result);
      }
      return;
    },
    async getDrawOperations({ commit, state }, data) {
      let result = await GET_DRAW_OPERATIONS(state.token, data);
      if (result.data.length) {
        commit("setIsChangeDrawEditMode", true);
        commit("setSaveDrawOperations", result.data);
      }
      return result.data;
    },
    async getInvitedFriends({ commit, state }, data) {
      let result = await GET_BONUS(state.token, data);
      if (Array.isArray(result)) {
        return [];
      }
      let friends = result.data.bonuses;
      commit("setInvitedFriens", result.data);
      return friends;
    },
    async getInvitesLink({ commit, state }, id) {
      let result = await GET_INVITES_LINK(state.token, id);
      commit("setInvitedLink", result);
    },
    async setCreateNewCategory({ commit, state }, data) {
      let result = await CREATE_CATEGORY(state.token, data);
      if (result.id) {
        commit("saveCategories", [result]);
      }
    },
    async setEditCategory({ commit, state }, data) {
      let result = await EDIT_CATEGORY(
        state.token,
        JSON.stringify(data),
        data.id
      );
      if (result.id) {
        commit("editCategories", result);
      }
    },
    async setDeleteCategory({ commit, state }, id) {
      let result = await DELETE_CATEGORY(state.token, id);
      console.log({ result });
      commit("deleteCategories", id);
    },
    async getPaymentsTariffs({ commit, state }) {
      let result = await GET_TARIFF(state.token);
      commit("setPaymentsTariffs", result);
      return result;
    },
    async setPurchaseTariff({ state }, { tariff, type }) {
      let data = {
        tariff_id: tariff,
        sub_type: type,
      };
      await SET_PURCHASE_TARIFF(
        state.token,
        state.currentCustomer.customer_id,
        JSON.stringify(data)
      ).then(() => {
        return;
      });
    },
    async setSettingsPush({ commit, state }, value) {
      let data = {
        daily_notification: value,
      };
      await SET_SETTINGS_PUSH(
        state.token,
        state.currentCustomer.customer_id,
        JSON.stringify(data)
      );
      commit("setChangeGlibalNotification", value);
    },
  },
  getters: {
    perPageName: (state) => {
      return state.perPage;
    },
    token: (state) => {
      return state.state;
    },
    getCurrency: (state) => {
      return state.currency;
    },
    getMainCurrency: (state) => {
      return state.mainCurrency;
    },
    getCustomers: (state) => {
      return state.customers;
    },
    getCurrentLang: (state) => {
      return state.currentLang;
    },
    getOperations: (state) => {
      return state.operations;
    },
    currentCustomer: (state) => {
      return state.currentCustomer;
    },
    operationsCategories: (state) => {
      return state.categories;
    },
    getSavedOperation: (state) => {
      return state.savedOperation;
    },
    createdInfo: (state) => {
      return state.createdInfo;
    },
    isShowGlobalAnalitycsBlock: (state) => {
      return state.isShowGlobalAnalitycsBlock;
    },
    isOpenMenuSideBar: (state) => {
      return state.isOpenMenuSideBar;
    },
    openedOperation: (state) => {
      return state.openedOperation;
    },
    mainAnalytics: (state) => {
      return state.mainAnalytics;
    },
    typeOperations: (state) => {
      return state.typeOperations;
    },
    activeAnalyticsData: (state) => {
      return state.activeAnalyticsData;
    },
    drawOperations: (state) => {
      return state.drawOperations;
    },
    isDrawEditMode: (state) => {
      return state.isDrawEditMode;
    },
    incomeCategories: (state) => {
      return state.incomeCategories;
    },
    costCategories: (state) => {
      return state.costCategories;
    },
    otherCategories: (state) => {
      return state.otherCategories;
    },
    globalNotification: (state) => {
      return state.globalNotification;
    },
    getInvitedFriends: (state) => {
      return state.invitedFriends;
    },
    getInvitedLink: (state) => {
      return state.invitedLink;
    },
    activeAnalyticType: (state) => {
      return state.activeAnalyticType;
    },
    setMainBonus: (state) => {
      return state.setMainBonus;
    },
    analyticsOperations: (state) => {
      return state.analyticsOperations;
    },
    paymentsTariffs: (state) => {
      return state.paymentsTariffs;
    },
  },
};
